import styled from "styled-components/macro";
import {useState} from "react";
import NavLink from "./nav_link";
import TopMenu from "./top_menu";
import {themecolors} from "../utils/themecolors";
import {ArrowUpWideNarrow, ChevronDown, Clock, MessageCircle, Rocket, TrendingUp} from "lucide-react";

const Outer = styled.div``;
const Inner = styled.div``;
const Item = styled.div``;
const TopSort = styled.div``;
const Time = styled.div``;
const Toggles = styled.div``;
const Toggle = styled.div``;

const SORT_MAPPING = {
    old: 'Old',
    new: 'New',
    controversial: 'Worst',
    top: 'Top',
    rising: 'Rising',
    active: 'Active',
}

const SHORT_TIMEFRAME_MAPPING = {
    hour: '1h',
    day: '1d',
    week: '1w',
    month: '1m',
    all: 'all',
}

const listingPath = (community, sort, customFeed) => {
    if (customFeed) return `/feed/${customFeed.id}/${customFeed.slug}/${sort}`;
    return community && community !== 'home' ? `/c/${community}/${sort}` : `/${sort}`;
}

const NewSortBar = styled(({className, community, sort, timeframe, customFeed, refresh}) => {
    const [sorting, setSorting] = useState(false);
    const timeframeMapping = timeframe && sort === 'top' ? `(${SHORT_TIMEFRAME_MAPPING[timeframe.toLowerCase()]})` : false;
    const handleTopSort = () => {
        if (sort === 'top') {
            setSorting(!sorting);
        }
    };
    return (
        <Outer className={`${className} sort-feed-desktop`}>
            <Inner>
                <NavLink activeOnlyWhenExact href={listingPath(community, '', customFeed)} onRefresh={refresh} react_route>
                    <Item className={'item'}>
                        <Rocket size={18} />
                            Hot
                    </Item>
                </NavLink>
                <NavLink href={listingPath(community, 'active', customFeed)} onRefresh={refresh} react_route>
                    <Item className={'item'}>
                        <MessageCircle size={18} />
                        Active
                    </Item>
                </NavLink>
                <NavLink href={listingPath(community, 'new', customFeed)} onRefresh={refresh} react_route>
                    <Item className={'item'}>
                        <Clock size={18} />
                        New
                    </Item>
                </NavLink>
                <NavLink href={listingPath(community, 'rising', customFeed)} onRefresh={refresh} react_route>
                    <Item className={'item'}>
                        <TrendingUp size={18} />
                        Rising
                    </Item>
                </NavLink>
                <TopSort>
                    <NavLink href={listingPath(community, 'top', customFeed)} react_route>
                        <Item className={"item"} onClick={handleTopSort}>
                            <ArrowUpWideNarrow size={18} />
                            Top {timeframeMapping && <Time>{timeframeMapping} <ChevronDown size={14} /></Time>}
                        </Item>
                    </NavLink>
                    {sorting && <TopMenu community={community} customFeed={customFeed} onClose={() => setSorting(false)}/>}
                </TopSort>
            </Inner>
        </Outer>
    );
})`
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  border-radius: 4px;
  margin-bottom: 12px;

  
  ${Item} {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-weight: 600;
    font-size: 13px;
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_high_impact_text};
    text-transform: uppercase;
    padding: 0px 18px;
    height: 36px;
    margin-right: 6px;
    cursor: pointer;
  }
  
  ${Item} svg {
    margin-right: 8px;
  }
  .active ${Item}, ${Item}:hover {
    background-color: ${({theme}) => theme.color.name === 'dark' ? theme.dark_border : '#80808012'};
    border-radius: 6px;
    color: ${({theme}) => theme.color.name === 'dark' ? theme.placeholder_white_2 : themecolors.light_high_impact_text};
  }
  
  ${Inner} {
    max-width: ${({theme}) => theme.fullWidth ? '100%' : '1360px'};
    margin: 0 auto;
    font-weight: 500;
    display: flex;
    height: 52px;
    margin: 0 12px;
    align-items: center;
    overflow-x: auto;
  }

  ${Toggles} {
    display: flex;
    margin-left: auto;
  }
  ${Toggles} ${Toggle} {
    padding: 8px;
    cursor: pointer;
  }
  ${Toggle} svg {
    width: 22px;
    height: 22px;
    fill: #8c8b8b;
  }
  ${Toggle}.active svg {
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : '#80808012'};
  }
  ${Time} {
    display: flex;
    align-items: center;
    margin-left: 6px;
  }
  ${Time} svg {
    margin-right: 0;
    margin-left: 2px;
  }
  .active-feed {
    background-color: ${({theme}) => theme.color.name === 'dark' ? theme.white_1.color : '#80808012'};
    color: ${({theme}) => theme.color.name === 'dark' ? 'black' : 'white'};
    font-weight: 500;
  }

  @media only screen and (max-width: 780px) {
    & {
      display: none;
    }
  }
  
`;

export default NewSortBar;